import { AppTarget, Environment } from 'fym-common/src/config/types';
import { appConfig } from './appConfig';
import { ConfigSchema, Music24Platform } from './types';

const platform = process.env.CONFIG_PLATFORM as Music24Platform;
const target = AppTarget.smartlinks;
const environment = process.env.CONFIG_ENVIRONMENT as Environment;
export const config: ConfigSchema = appConfig(platform, target, environment);
